import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

export default class Reviews extends Component {
  render() {
    return (
      <div className={css(styles.notification)}>
        {this.props.children}
      </div>
    );
  }
}

Reviews.defaultProps = {};

Reviews.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
  ]).isRequired,
};

const styles = StyleSheet.create({
  notification: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    width: '100vw',
    color: Theme.white,
    fontSize: 14,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    backgroundColor: '#16345a',

    [Theme.mobile_query]: {
      height: 'auto',
      padding: 15,
      flexWrap: 'wrap',
      lineHeight: 1.7,
      zIndex: 99,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/NotificationBar/index.js